import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import classNames from 'classnames';
var css = {
  "search": "rui-owJ3W",
  "option": "rui-RFqlr",
  "recentSearchItem": "rui-sRHR6",
  "suggestion": "rui-kudsJ",
  "suggestionCategory": "rui-1r1SF",
  "currentSearch": "rui-ToQNb",
  "icon": "rui-4Gsnj",
  "autosOption": "rui-BaHnN",
  "recentSearchHeading": "rui-ZStik",
  "lowercase": "rui-xbpMn",
  "header": "rui-cF4qg",
  "visible": "rui-eCpOG"
};
import Icon from '../Icon/Icon';
var Suggestion = /*#__PURE__*/function (_React$Component) {
  function Suggestion(props) {
    var _this;
    _classCallCheck(this, Suggestion);
    _this = _callSuper(this, Suggestion, [props]);
    _this.bindings = {
      onClick: _this.onClick.bind(_this),
      onMouseOver: _this.onMouseOver.bind(_this)
    };
    return _this;
  }
  _inherits(Suggestion, _React$Component);
  return _createClass(Suggestion, [{
    key: "onMouseOver",
    value: function onMouseOver() {
      this.props.onMouseOver(this.props.index);
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.props.onClick(this.props.index);
    }
  }, {
    key: "formatTitle",
    value: function formatTitle(title, value) {
      var _a;
      if (!value || typeof value !== 'string') {
        return title;
      }
      return /*#__PURE__*/React.createElement("span", {
        className: css.suggestion
      }, (_a = title === null || title === void 0 ? void 0 : title.toLowerCase()) === null || _a === void 0 ? void 0 : _a.split(value.toLowerCase()).reduce(function (prev, current, i) {
        if (!i) {
          return [current];
        }
        var alteredValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        return prev.concat(/*#__PURE__*/React.createElement("span", {
          key: value + current,
          "data-aut-id": "suggestion",
          className: css.currentSearch
        }, alteredValue), current === null || current === void 0 ? void 0 : current.toLowerCase());
      }, []));
    }
  }, {
    key: "render",
    value: function render() {
      var title;
      var isAutosSearch = this.props.isAutosSearch;
      if (this.props.suggestion.type === 'didyoumean' && this.props.index === 0) {
        title = /*#__PURE__*/React.createElement("span", {
          className: css.suggestion
        }, this.props.translations.didYouMean ? this.props.translations.didYouMean : '', " : ", /*#__PURE__*/React.createElement("span", {
          className: css.currentSearch,
          "data-aut-id": "didyoumean"
        }, this.props.suggestion.title));
      } else {
        title = this.formatTitle(this.props.suggestion.title, this.props.value);
      }
      return /*#__PURE__*/React.createElement("li", {
        role: "option",
        className: classNames([css.option, isAutosSearch ? css.autosOption : null]),
        "aria-selected": this.props.isSelected,
        onMouseOver: this.bindings.onMouseOver,
        onFocus: function onFocus() {},
        "data-aut-id": "searchSuggestionItem",
        onClick: this.bindings.onClick,
        onKeyPress: this.bindings.onClick,
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("div", null, isAutosSearch && /*#__PURE__*/React.createElement(Icon, {
        icon: 'search',
        size: 16.25,
        color: "primaryLight2"
      }), title, this.props.suggestion.subtitle && !isAutosSearch && /*#__PURE__*/React.createElement("span", {
        className: css.suggestionCategory
      }, this.props.suggestion.subtitle)));
    }
  }]);
}(React.Component);
Suggestion.defaultProps = {
  icons: '',
  value: '',
  translations: {}
};
export default Suggestion;